import layouts from './layouts'



export function defineLayouts(customLayouts) {
  if (!customLayouts) {
    return
  }
  for (const layout of customLayouts) {
    layouts.push(layout)
  }
}
